import * as React from 'react';
import { HelpIcon } from 'glints-aries';
import { FormattedMessage } from 'react-intl';

import { EmptyView } from 'src/components/EmptyView';
import * as Styled from 'src/modules/Company/CompanyListEmptyView.sc';

export const CompanyEmptyListView: React.FC<
  React.PropsWithChildren<unknown>
> = () => (
  <EmptyView>
    <Styled.HelpIconWrapper>
      <HelpIcon />
    </Styled.HelpIconWrapper>
    <Styled.NoResultsTitle>
      <FormattedMessage
        id="no.results.found"
        defaultMessage="No results found"
        tagName="span"
      />
    </Styled.NoResultsTitle>
    <Styled.NoResultsDescription>
      <FormattedMessage
        id="try.expanding.search"
        defaultMessage="Try expanding your search by clicking on the filters above."
        tagName="span"
      />
    </Styled.NoResultsDescription>
  </EmptyView>
);
